import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Wysiwyg from "../components/wysiwyg.react";
import InputCustom from "../components/inputCustom.react";
import { Link } from "react-router";
import "./mediaCategories.css";
import Modal from "../components/modal.react";
import Table from "./table.react";
import InputWithError from "../components/inputWithError.react";

export default class MediaCategory extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      actions,
      mediaCategories: { mediaCategories: { meta: mediaCategoriesMeta } },
      notificationSystem
    } = this.props;

    actions
      .getMediaCategories(mediaCategoriesMeta)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  }

  addCategory = () => {
    const {
      actions,
      notificationSystem,
      mediaCategories: {
        forms: { createMediaCategory: { fields } },
        mediaCategories: { meta: mediaCategoriesMeta }
      }
    } = this.props;
    let data = fields;
    actions.createMediaCategory(data).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        actions
          .getMediaCategories(mediaCategoriesMeta)
          .then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
        actions.setShouldMenuLeftRerender(true);
      }
    });
    actions.setIsAddMediaCategoryModalVisible(false);
  };

  openAddMediaCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsAddMediaCategoryModalVisible(true);
  };

  closeAddMediaCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsAddMediaCategoryModalVisible(false);
  };

  render() {
    const {
      actions,
      mediaCategories,
      msg: { mediaCategories: msg },
      history,
      notificationSystem
    } = this.props;

    const isAddModalVisible = true;

    const addMediaCategoryFormProps = {
      feature: "mediaCategories",
      actions: actions,
      form: mediaCategories.forms.createMediaCategory,
      formName: "createMediaCategory",
      msg: msg.forms.createMediaCategory,
      validateFormField: actions.validateFormFieldMediaCategories
    };

    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <h2 className="col-xs-8">Media</h2>
          <div className="col-xs-4">
            <button className="info" onClick={this.openAddMediaCategoryModal}>
              dodaj kategorię
            </button>
          </div>
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">Kategorie</div>
              <div className="content-wrapper">
                <Table
                  history={history}
                  mediaCategories={mediaCategories}
                  tableWidth={1000}
                  tableHeight={300}
                  actions={actions}
                  notificationSystem={notificationSystem}
                />
              </div>
            </div>
          </div>

          {mediaCategories.forms.getIn([
            "createMediaCategory",
            "isAddModalVisible"
          ]) && (
            <Modal
              closeModalAction={this.closeAddMediaCategoryModal}
              enterAction={this.addCategory}
              handleKeyDownEvent={true}
            >
              <div className="row">
                <h3 className="col-xs-12">Dodaj nową kategorię mediów</h3>
                <div className="col-xs-12">
                  <InputWithError
                    placeholder="Nazwa kategorii"
                    field="name"
                    {...addMediaCategoryFormProps}
                  />
                </div>
                <div className="col-xs-12">
                  <InputWithError
                    placeholder="Opis kategorii"
                    field="description"
                    {...addMediaCategoryFormProps}
                  />
                </div>
                <div className="col-xs-12">
                  <button className="success" onClick={this.addCategory}>
                    Dodaj kategorię
                  </button>
                </div>
              </div>
            </Modal>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/mediaCategories/mediaCategories.react.js